import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { useSearchParams } from 'react-router-dom'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { promocodeApi } from '../../../features/promocode/promocode'
import AddPromocodeDialog from './components/AddPromocodeDialog'
import PromocodeTable from './components/PromocodeTable'
import { Content, Header, Title, Wrapper } from './style'

const PromocodeListPage = () => {
    const { formatMessage } = useIntl()
    const [searchParams, setSearchParams] = useSearchParams('')
    const [page, setPage] = React.useState(+searchParams.get('page') || 1)
    const [rowsPerPage, setRowsPerPage] = React.useState(
        +searchParams.get('size') || 5,
    )
    const {
        data: promocodeResponse = null,
        isFetching,
    } = promocodeApi.useFetchAllGeneralPromocodeQuery({
        page: +page - 1,
        size: +rowsPerPage,
    })
    const [deleteGeneralPromocode, { isLoading: isDeleting }] =
        promocodeApi.useDeleteGeneralPromocodeMutation()

    const handleDelete = async (id: number) => {
        try {
            await deleteGeneralPromocode(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (e) { }
    }

    useEffect(() => {
        const params = {
            page: page.toString(),
            size: rowsPerPage.toString(),
        }
        setSearchParams(params)
    }, [rowsPerPage, page])

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3> {formatMessage({ id: 'promocode' })} </H3>
                    </Title>
                    <AddPromocodeDialog />
                </Header>

                {(isFetching || isDeleting) ? (
                    <LinearProgress />
                ) : (
                    promocodeResponse && (
                        <PromocodeTable
                            isFetching={isFetching}
                            promocodeData={promocodeResponse.data}
                            pageNumber={promocodeResponse.pageNumber}
                            totalCount={promocodeResponse.totalCount}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                            onDelete={handleDelete}
                        />
                    )
                )}
            </Content>
        </Wrapper>
    )
}

export default PromocodeListPage
